import { environment } from "../environments/environment";

export class AppConstants {
  public static API_BASE_URL = environment.mainUrl;
  public static AUTH_API_URL = environment.authServiceUrl;
  public static FILE_SERVICE_URL = environment.fileServerUrl;
  public static FILE_SERVER = AppConstants.FILE_SERVICE_URL + "/priv";
  public static FILE_SERVER_CATEGORY_ORDER = AppConstants.FILE_SERVICE_URL + "/categories";
  public static NEWS_SERVER = environment.newsServerUrl + "/general/news";
  public static MAIL_SERVER = environment.mailServerUrl;
  public static NOTIFICATION_SERVER_WS = environment.notificationServerUrl;
  public static NOTIFICATION_SERVER_HTTP = environment.notificationServerEndpointUrl;
  public static NOTIFICATION_SERVER_GET_RECENT = AppConstants.NOTIFICATION_SERVER_HTTP + "/api/recent";

  /* OCCON Colors */
  public static COLOR_RED_MID = "df001a";
  public static COLOR_GREEN_MID = "009933";
  public static COLOR_ORANGE = "ffa500";
  public static COLOR_GREY_MID = "818187";

  /* AuthService */
  public static LOGIN = AppConstants.AUTH_API_URL + "/nocco";
  public static REQEUST_PASSWORD_RESET = AppConstants.AUTH_API_URL + "/nocco/requestpasswordreset";
  public static REQUEST_LOGIN_TOKEN = AppConstants.AUTH_API_URL + "/nocco/loginToken";
  public static SSO_TOKEN_LOGIN = AppConstants.AUTH_API_URL + "/nocco/ssologin";
  public static AUTH_CHECK = AppConstants.AUTH_API_URL + "/nocco/check";
  public static AUTH_SETUP_MULTIFACTOR = AppConstants.AUTH_API_URL + "/nocco/setupmultifactorauthentication";
  public static AUTH_CONFIRM_MULTIFACTOR = AppConstants.AUTH_API_URL + "/nocco/confirm";
  public static AUTH_GET_MULTIFACTOR = AppConstants.AUTH_API_URL + "/nocco/multifactorauthenticationqrcode";
  public static AUTH_DEACTIVATE_MULTIFACTOR = AppConstants.AUTH_API_URL + "/nocco/deactivatemultifactorauthentication";
  public static SUBMIT_TOTP_CODE = AppConstants.AUTH_API_URL + "/nocco/verify";
  public static REGISTRATION_TOKEN_GENERATION = AppConstants.AUTH_API_URL + "/nocco/generateregistrationtoken";
  public static CONFIRM_TOKEN_AND_REGISTER = AppConstants.AUTH_API_URL + "/nocco/registeruser";
  public static AUTH_GET_AUTHORITY_LIST = AppConstants.AUTH_API_URL + "/sso";
  public static AUTH_LAST_SELECTED_CLIENT = "lastSelectedClient";
  public static AUTH_LOGIN_SSO = AppConstants.AUTH_API_URL + "/nocco/sso";
  public static AUTH_REGISTER_SSO = AppConstants.AUTH_API_URL + "/nocco/ssoregister";
  public static AUTH_RESET_PASSWORD = AppConstants.AUTH_API_URL + "/nocco/resetpassword";
  public static AUTH_SET_NEW_PASSWORD = AppConstants.AUTH_API_URL + "/nocco/changepassword";

  /* RegisterService */
  public static GET_ALL_COMPANIES = AppConstants.API_BASE_URL + "/public/register/getallcompanies";
  public static GET_ALL_COMPANIES_WITHOUT_TEST = AppConstants.API_BASE_URL + "/public/register/getallcompanieswithouttestcompanies";
  public static GET_ALL_COUNTRIES = "https://restcountries.eu/rest/v1/all";

  /* UserService */
  public static USER_MAIL_VALIDATION = AppConstants.API_BASE_URL + "/general/user/mailvalidation";

  /* News Service */
  public static GET_NEWS = AppConstants.NEWS_SERVER + "/getrecent";

  /* Mail Service */
  public static SEND_MAIL = AppConstants.MAIL_SERVER + "/sendMail";
  public static INVITATION_MAIL = AppConstants.API_BASE_URL + "/general/rfx/invitationMail";

  /* LocalStorage Keys */
  public static AUTH_KEY = "occonAuthKey";

  public static HTTP_REQUEST_TIMEOUT = 600000; // in milliseconds
  public static HTTP_REQUEST_RETRIES = 2;

  /* File Service */
  public static GET_BY_ID = "/id";
  public static GET_FILE_LIST = "/list";
  public static GET_FILE_COUNT = "/count";

  public static GLOBAL_FILE_BY_ID = AppConstants.FILE_SERVER + AppConstants.GET_BY_ID;
  public static GLOBAL_FILES_LIST = AppConstants.FILE_SERVER + AppConstants.GET_FILE_LIST;

  /* Notification Room */
  public static NOTIFICATION_ROOM_ALL = "all";
  public static NOTIFICATION_ROOM_GLOBAL = "global";
  public static NOTIFICATION_ROOM_PERSONAL = "user";

  /* REGEX PATTERNS */
  public static PASSWORD_VALIDATION_REGEX = "^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?\\d)|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z0-9])|(?=.*?[A-Z])(?=.*?\\d)(?=.*?[^a-zA-Z0-9])|(?=.*?[a-z])(?=.*?\\d)(?=.*?[^a-zA-Z0-9])).{8,}$";
  public static EMAIL_VALIDATION_REGEX = "^[a-zA-Z0-9](\\.?[a-zA-Z0-9_-]){0,}\\b@\\b([a-zA-Z0-9-]{1,32}\\.)+([a-zA-Z]{2,10})$";
  public static PHONE_VALIDATION_REGEX = "[+]?[0-9\-\ ]{5,25}";

  /* MISC */
  public static UUID_EMPTY = "00000000-0000-0000-0000-000000000000";
}
